/**
 * Input validation utility functions
 */

export const validateAlphabetsWithSpace = (value) => {
  // Allows only alphabets and spaces
  return value.replace(/[^a-zA-Z\s]/g, '');
};

export const validateAlphabetsOnly = (value) => {
  // Allows only alphabets (no spaces)
  return value.replace(/[^a-zA-Z]/g, '');
};

export const validateNumeric = (value, maxLength = null) => {
  // Allows only numbers and enforces max length if provided
  let result = value.replace(/\D/g, '');
  if (maxLength) {
    result = result.slice(0, maxLength);
  }
  return result;
};

export const validateAlphaNumeric = (value) => {
  // Allows alphanumeric characters
  return value.replace(/[^a-zA-Z0-9]/g, '');
};

export const validateServiceDocumentNumber = (value) => {
  // Allows alphanumeric characters and common service/document number separators.
  return value.replace(/[^a-zA-Z0-9\-_/!#]/g, '');
};

export const validateName = (value) => {
  // Allows alphabets, spaces, and common name characters like hyphen, apostrophe
  return value.replace(/[^a-zA-Z\s]/g, '');
};

export const validateAddress = (value) => {
  // Allows alphanumeric, spaces, and common address characters
  return value.replace(/[^a-zA-Z0-9\s.,#\-/]/g, '');
};

export const validateEmail = (email) => {
  // Basic email validation
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validateMobile = (value) => {
  // Validates Indian mobile numbers
  const re = /^[6-9]\d{9}$/;
  return re.test(value);
};

export const validatePincode = (value) => {
  // Validates 6-digit Indian pincode
  const re = /^\d{6}$/;
  return re.test(value);
};
